const localizationBundle = {
  'app.button.Submit': 'Enviar',
  distribute: 'Distribuye',
  recive: 'Recibe',
  resources: 'Recursos',
  intro: {
    main: 'Leveler es una herramienta para que la población económicamente estable pueda ayudar a trabajadorxs independientes \n'
            + 'que han perdido trabajo o han sido afectados económicamente por la pandemia',
    distribute: 'Haz click en "Distribuye" y leveler seleccionará al azar 10 usuarios que necesitan tu ayuda.\n'
            + 'Haz click en el link de paypal de cada usuario y envia dinero. Cualquier cantidad es bienvenida.',
    mobile: 'Esta es un herramienta mobile. Participa desde tu teléfono.',
    lastSignup: 'último registro',
    lastUpvote: 'último voto',
    lastContrib: 'última distribución',
  },
  distributePage: {
    contribute: 'Contribuí.',
    textIntro: 'Los siguientes usuarios han sido seleccionados de ',
    textImportant: 'manera aleatoria.',
    textOutro: ' Procura mandar la misma cantidad a todos.',
    main: 'Leveler es una base de datos de trabajadorxs independientes que se quedaron sin ingresos a causa de la pandemia. ',
    thanks: '¡Gracias!',
    interimSignUpPrompt: 'Actualmente estamos buscando más personas para inscribirse. Si usted o alguien que conoce está interesado, ¡haga clic en el botón a continuación!',
  },
  contributePage: {
    header: '¿Cómo puedo ayudar?',
    text: 'El equipo de leveler está formado por voluntarios. No tenemos fondos y estamos organizando comunidades dentro y fuera de\n'
            + 'Estados Unidos. Si te gusta el proyecto y te gustaría ayudarnos haz click en el icono de paypal.',
  },
  contributeBand: {
    volunteerLed: '📢 leveler es llevada acabo por voluntarios',
    volunteerContribute: 'para contribuir al equipo ❤️',
  },
  clickHere: ' Da Click Aquí ',
  guidelinesPage: {
    header: 'Instrucciones',
    important: 'Llena la forma sólo si has sido impactadx económicamente por el COVID-19.',
    listSecond: 'Si ya recibiste suficiente dinero por favor escríbenos a mexico@leveler.info y te quitaremos de la lista.',
    listThird: 'Si recibiste más dinero del que necesitas, redistribúyelo.',
    legend: '* Los campos con asterisco son públicos y obligatorios',
  },
  registrationPage: {
    location: 'Ciudad',
    locationDescription: 'Ingresa las siglas de tu ciudad',
    industry: 'Industria',
    arts: 'Artes',
    nightLife: 'Vida Nocturna',
    production: 'Producción',
    hospitality: 'Hospitalidad',
    music: 'Música',
    other: 'Otro',
    otherPlaceHolder: 'Ingresa Otra Industria',
    context: 'Contexto *',
    contextDescription: 'Si te sientes cómodo, comparte tu situación actual y cómo fuiste afectado por la pandemia.',
    payment: 'Pago',
    paymentURL: 'Postea el url público de tu paypal',
    social: 'Social',
    socialDescription: 'Comparte tus perfiles de redes sociales. Estos datos no serán públicos pero un administrador te va a contactar para verificar tu identidad.',
    suggestions: 'Sugerencias',
    suggestionsDescription: 'Contáctanos si tienes ideas para mejorar leveler.',
    submit: 'Enviar',
    urlError: 'Agrega un URL válido',
  },
  footer: {
    about: 'Acerca de',
  },
};
export default localizationBundle;
